import _classCallCheck from "/opt/build/repo/docs/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import { augmentError, initParser, state } from "./traverser/base";
import { parseFile } from "./traverser/index";
export var File = function File(tokens, scopes) {
  _classCallCheck(this, File);
  this.tokens = tokens;
  this.scopes = scopes;
};
export function parse(input, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled) {
  if (isFlowEnabled && isTypeScriptEnabled) {
    throw new Error("Cannot combine flow and typescript plugins.");
  }
  initParser(input, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled);
  var result = parseFile();
  if (state.error) {
    throw augmentError(state.error);
  }
  return result;
}